import { render, staticRenderFns } from "./PS-tab.vue?vue&type=template&id=0b22b6ac"
import script from "./PS-tab.vue?vue&type=script&lang=js"
export * from "./PS-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports